export class SearchByConversionDto {
    constructor(public FieldId: number, public Value: string) {
    }
}